import API from "@/api";

export default {
  namespaced: true,

  state: {},

  actions: {
    async create({ dispatch }, payload) {
      try {
        await API.Physicals.create(payload);
      } catch (e) {
        throw e;
      }
    }
  },

  mutations: {},

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/physicals.js